import { executeRequest, getResponseBody } from './apiRequest';
import { SharePointApiError } from './errors';
import type { ApiRequest, ApiResponse } from './types';

const handleResponse = (request: ApiRequest, response: Response) => {
  if (response.ok) {
    return getResponseBody(response);
  }

  throw new SharePointApiError(request, response.statusText, response.status, response.headers);
};

type SharePointApiRequest = <TResponse>(request: ApiRequest) => Promise<ApiResponse<TResponse>>;
const sharePointApiRequest: SharePointApiRequest = async (request) => {
  try {
    const response = await executeRequest(request);
    const body = await handleResponse(request, response);

    return {
      body,
      headers: response.headers,
    };
  } catch (error) {
    if (error instanceof SharePointApiError) {
      throw error;
    }

    throw new SharePointApiError(request, error);
  }
};

export default sharePointApiRequest;
